import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import { Item, SolarCalcPage } from '@/constants/solar-calculator';
import NextImage from '@/components/NextImage';

export default function Step1({ calObj, callBack }: any) {
    const { useLang, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const {locale} = useRouter();
    const [checked, setChecked] = useState(calObj?.check1 ?? '');
    const items: Item[] = [
        {
            webp: require('@publicLocal/solar-calculator/pc/1_1.webp'),
            img: require('@publicLocal/solar-calculator/pc/1_1.jpg'),
            text: t('step1_text1'),
            key: 'outdoor',
        },
        {
            webp: locale==='au' ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719366900052/Rectangle%209.jpg' : require('@publicLocal/solar-calculator/pc/1_2.webp'),
            img: locale==='au' ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719366900052/Rectangle%209.jpg' : require('@publicLocal/solar-calculator/pc/1_2.jpg'),
            text: t('step1_text2'),
            key: 'home',
        },
        {
            webp: locale === 'au' ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719367099255/Rectangle%2010.jpg' : require('@publicLocal/solar-calculator/pc/1_3.webp'),
            img:  locale === 'au' ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719367099255/Rectangle%2010.jpg' : require('@publicLocal/solar-calculator/pc/1_3.jpg'),
            text: t('step1_text3'),
            key: 'work',
        },
        {
            webp: locale === 'au' ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719367197833/20240626-095944.jpeg' : require('@publicLocal/solar-calculator/pc/1_4.webp'),
            img: locale === 'au' ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719367197833/20240626-095944.jpeg' : require('@publicLocal/solar-calculator/pc/1_4.jpg'),
            text: t('step1_text4'),
            key: 'others',
        },
    ];
    const handleCheck = (key: string) => {
        setChecked(key === checked ? '' : key);
        callBack({ ...calObj, currentStep: key === checked ? 0 : 1, check1: key === checked ? '' : key });
    };
    const handleNext = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step2 }, true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process1',
            step: 'Scenario_1',
            product_name: 'EcoFlow Solar Panel',
            button_name: 'Next',
            option_name: items?.find((item: Item) => item.key === checked)?.text,
        });
    };
    return (
        <div className={`step1 ${css.step1}`}>
            <p className="step1-title">{t('step1_title')}</p>
            <ul className="step1-box">
                {items?.map((item: any, k: number) => (
                    <li className="step1-item" key={item?.text} onClick={() => handleCheck(item?.key)}>
                        <div className="img-box">
                            <NextImage webpSrc={item?.webp || item?.img} src={item?.img} alt={item.text} aria-label={item.text} />
                            {checked === item?.key && (
                                <>
                                    <div className="mask"></div>
                                    <EFChecked className="checked" />
                                </>
                            )}
                        </div>
                        <p className="img-text">{item?.text}</p>
                    </li>
                ))}
            </ul>
            <button className="next-btn" disabled={!checked} onClick={handleNext}>
                {t('common_next')}
            </button>
        </div>
    );
}
